export const getTableColumnExtensions = (tableColumns) => {
    let columnExtensions = [];

    tableColumns.forEach(column => {
        columnExtensions.push({
            columnName: column.name,
            wordWrapEnabled: true,
            width: column.width,
        });
    });

    return columnExtensions;
};